// 关于我们
import aboutUs from '@/views/about_us/index.vue' // 首页
import researchInfo from '@/views/about_us/focus/shgsyx/research_info.vue' // 研学 详情页

const routes = [
    {
        path: '/aboutUs',
        component: aboutUs,
        meta: {
            title: '益学堂-关于我们',
        },
        // redirect: '/aboutUs/about',
        children: [
            {
                path: '',
                // path: 'about',
                component: () => import('@/views/about_us/about/index.vue'), // 关于益学
            },
            {
                path: 'focus',
                component: () => import('@/views/about_us/focus/index.vue'), // 益学聚焦
            },
            {
                path: 'contact',
                component: () => import('@/views/about_us/contact/index.vue'), // 联系我们
            },
            {
                path: 'warn',
                component: () => import('@/views/about_us/warn/index.vue'), // 益学提醒
            },
        ]
    },
    {
        path: '/aboutUs/researchInfo',
        name: 'researchInfo',
        component: researchInfo,
    },
]

export default routes;